// Module
var code = " ";
// Exports
module.exports = code;